// extracted by mini-css-extract-plugin
export var component = "CiteThisPage-module--component--f9958";
export var fadePop = "CiteThisPage-module--fade-pop--493dc";
export var growHeightIn = "CiteThisPage-module--grow-height-in--57d15";
export var icon = "CiteThisPage-module--icon--10244";
export var iconWrapper = "CiteThisPage-module--iconWrapper--6101b";
export var label = "CiteThisPage-module--label--fd630";